export default __webpack_public_path__ + "static/media/ru.4d7206c7.svg";